import * as React from 'react';
import { IApiClient } from '@mam/main/ApiClient';

export const Context = React.createContext<Record<'api' | 'pigeon', IApiClient> | null>(null);
Context.displayName = 'ApiHooks.Context';
